module.exports = __webpack_public_path__ + "img/icn_brand17_black.d85a0141.svg";